import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root' 
})
export class SharedDataService {
  private dataSubject = new BehaviorSubject<any>(null);
  data$ = this.dataSubject.asObservable(); 

  setData(data: any) {
    this.dataSubject.next(data);
  }

  clearData() {
    this.dataSubject.next(null); 
  }

  storeData(data: {name: string, data: any}) {
   
   // join datas if exists
   let dataObject = JSON.parse(localStorage.getItem('data') || '{}');
    if (!dataObject[data.name]) {
      dataObject[data.name] = data.data;
      localStorage.setItem('data', JSON.stringify(dataObject));
    } else {
      dataObject[data.name] = data.data;
      localStorage.setItem('data', JSON.stringify(dataObject));
    }
  }

  getStoredData(key?: string) {
    if (!key) {
      return JSON.parse(localStorage.getItem('data') || '{}');
    } else {
      const data = JSON.parse(localStorage.getItem('data') || '{}');
      if (data) {
        return data[key] || null;
      } else {
        return null;
      }
    }
  }

  removeStoredData(storeKey?: string) {
    if (!storeKey) {
      localStorage.removeItem('data');
    } else {
      localStorage.removeItem(storeKey);
    }
  }
}
